"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = exports.getAllErrors = exports.mergeRequiredFieldErrorsIntoUpdatedFields = exports.getEmptyRequiredFieldErrors = void 0;
const utils_1 = require("../utils");
/**
 * Creates an emptyRequiredFieldErrors object and appends errors from
 * any standard field the is missing required data
 *
 * @param {Object} { fields, entityData, updatedFields }
 * @returns {Object} { fields, entityData, updatedFields, emptyRequiredFieldErrors }
 */
function getEmptyRequiredFieldErrors({ fields, entityData, updatedFields }) {
    const emptyRequiredFieldErrors = fields.reduce((emptyRequiredFieldErrors, field) => {
        const isEmpty = hasNoValue(entityData, field, updatedFields);
        if (field.isRequired && isEmpty && field.isVisible) {
            emptyRequiredFieldErrors[field.path] = field.isRequiredMsg;
        }
        return emptyRequiredFieldErrors;
    }, {});
    return { fields, entityData, updatedFields, emptyRequiredFieldErrors };
}
exports.getEmptyRequiredFieldErrors = getEmptyRequiredFieldErrors;
function hasNoValue(entityData, field, updatedFields) {
    const noValueInEntityData = (0, utils_1.isFieldEmpty)((0, utils_1.getPropertyValue)(entityData, field.path, true));
    const fieldNotUpdated = !Object.prototype.hasOwnProperty.call(updatedFields, field.path);
    const noValueInUpdatedFields = fieldNotUpdated || (0, utils_1.isFieldEmpty)(updatedFields[field.path].value);
    const hasDefaultValue = fieldNotUpdated && (field.defaultValue || field.defaultSelection);
    if (fieldNotUpdated)
        return noValueInEntityData && !hasDefaultValue;
    return noValueInUpdatedFields;
}
/**
 * Merges any new required error messages into updatedFields
 * object so they are passed to field components
 *
 * @param {Object} { emptyRequiredFieldErrors, updatedFields }
 * @returns {Object} New updatedFields object
 */
function mergeRequiredFieldErrorsIntoUpdatedFields({ emptyRequiredFieldErrors, updatedFields }) {
    let updatedFieldsWithRequiredFieldErrors = Object.assign({}, updatedFields);
    Object.keys(emptyRequiredFieldErrors).forEach((path) => {
        // add errors array if it doesn't exist
        updatedFieldsWithRequiredFieldErrors[path] = updatedFieldsWithRequiredFieldErrors[path] || {
            errors: []
        };
        // if no errors are present in field, add required errors
        if (!updatedFieldsWithRequiredFieldErrors[path].errors.length) {
            updatedFieldsWithRequiredFieldErrors = Object.assign(Object.assign({}, updatedFieldsWithRequiredFieldErrors), { [path]: Object.assign(Object.assign({}, updatedFieldsWithRequiredFieldErrors[path]), { errors: [emptyRequiredFieldErrors[path]] }) });
        }
    });
    return updatedFieldsWithRequiredFieldErrors;
}
exports.mergeRequiredFieldErrorsIntoUpdatedFields = mergeRequiredFieldErrorsIntoUpdatedFields;
/**
 * Iterates through all errors in updatedFieldsWithErrors,
 * creates a flat list of deduped errors, and appends to allErrorsSet
 *
 * @param {Object} updatedFieldsWithErrors
 * @returns {{ updatedFieldsWithErrors: Object, allErrorsSet: Set }}
 */
function getAllErrors(updatedFieldsWithErrors) {
    const allErrors = Object.values(updatedFieldsWithErrors).reduce((allErrors, updatedField) => {
        const errorList = flattenErrorList(updatedField);
        return allErrors.concat(errorList);
    }, []);
    return { updatedFieldsWithErrors, allErrorsSet: new Set(allErrors) };
}
exports.getAllErrors = getAllErrors;
/**
 * Creates a flat list of all the error messages for a particular
 * field are contained in the updatedFields object
 *
 * @param {Object} updatedField
 */
function flattenErrorList(updatedField) {
    return updatedField.errors.reduce((allErrors, fieldErrors) => allErrors.concat(fieldErrors), []);
}
/**
 * Executes all functions in a list from left to right, where the return
 * value of the previous function is the argument to the next.
 * Ex: pipe(addOne, addTwo)(0) // 3
 *
 * Uses partial application; first an array of functions is provided and held in closure
 *
 * @param  {Function[]} fns
 */
function pipe(...functions) {
    /**
     * Then an argument is provided as the input to the first function
     *
     * @param  {*} arg
     */
    return (firstArgument) => functions.reduce((acc, f) => f(acc), firstArgument);
}
exports.pipe = pipe;
//# sourceMappingURL=error-utils.js.map